import React from "react";
import { useHistory } from "react-router-dom";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import routes from "common/routes";
import Link from "components/Link";
import Loader from "components/Loader";
import Snack from "components/Snack";
import { useRacehorse360Api } from "hooks/api";
import { toTitleCase } from "utils/horse";

import useStyles from "./styles";
import {
  withClickBlocker,
  WithClickBlockerProps
} from "../BlockableClickContext";

export interface Props extends WithClickBlockerProps {
  horse: racehorse360.IHorse;
}

const HorseWorkoutInfo = (props: Props) => {
  const { horse, handleBlockableLinkClick } = props;
  const classes = useStyles();
  const history = useHistory();
  const { useListHorseOnLists } = useRacehorse360Api();
  const { isLoading: isListHorseOnListsLoading, data: horseOnListsData } =
    useListHorseOnLists({
      query: {
        horseId: { value: horse.id },
        activeOnly: {
          value: true
        }
      },
      getOptions: {
        select: ["id", "list_type", "reason", "date_on", "comment"],
        orderBy: ["dateOn"]
      }
    });
  const horseOnLists = horseOnListsData?.horseOnLists;

  const handleMoreInfoClick = event => {
    const isBlockedClick = handleBlockableLinkClick
      ? handleBlockableLinkClick(event)
      : false;
    if (!isBlockedClick) {
      history.push(
        routes.horseDetails.path.replace(":horseId", String(horse.id))
      );
    }
  };

  const renderSnacks = list => {
    if (!horseOnLists?.length) {
      return "None";
    }
    return list.map(l => (
      <Snack
        key={l.id}
        text={l.listType}
        variant={"alert"}
        title={[format(parseISO(l.dateOn), "M/d/yy"), l.reason]
          .filter(Boolean)
          .join(" - ")}
      />
    ));
  };

  return (
    <Paper className={classes.root}>
      <Box className={classes.box}>
        <Typography className={classes.label}>Last Workout</Typography>
        <Typography
          className={clsx(classes.value, {
            [classes.none]: !horse?.lastWorkoutDate
          })}
        >
          {horse?.lastWorkoutDate
            ? format(parseISO(horse.lastWorkoutDate), "MMMM dd, yyyy")
            : "None"}
        </Typography>
      </Box>
      <Box className={classes.box}>
        <Typography className={classes.label}>Last Workout Track</Typography>
        <Typography
          className={clsx(classes.value, {
            [classes.none]: !horse?.lastWorkoutFacility
          })}
        >
          {toTitleCase(horse?.lastWorkoutFacility?.name) || "None"}
        </Typography>
      </Box>
      <Box className={classes.box}>
        <Typography className={classes.label}>Last Race</Typography>
        <Typography
          className={clsx(classes.value, {
            [classes.none]: !horse?.lastRaceDate
          })}
        >
          {horse?.lastRaceDate
            ? format(parseISO(horse.lastRaceDate), "MMMM dd, yyyy")
            : "None"}
        </Typography>
      </Box>
      <Box className={classes.box}>
        <Typography className={classes.label}>Last Race Track</Typography>
        <Typography
          className={clsx(classes.value, {
            [classes.none]: !horse?.lastRaceFacility
          })}
        >
          {horse.lastRaceFacility
            ? toTitleCase(horse.lastRaceFacility.name)
            : "None"}
        </Typography>
      </Box>
      <Box className={classes.box}>
        <Typography className={classes.label}>Currently Stabled At</Typography>
        <Typography
          className={clsx(classes.value, {
            [classes.none]: !horse.currentFacility
          })}
        >
          {toTitleCase(horse.currentFacility?.name)}
        </Typography>
      </Box>
      <Box className={classes.box}>
        <Typography className={classes.label}>Current Lists</Typography>
        <Box
          className={clsx(classes.snacks, {
            [classes.none]: !horseOnLists?.length
          })}
        >
          {isListHorseOnListsLoading ? (
            <Loader size={24} disableGutters={true} />
          ) : (
            renderSnacks(horseOnLists)
          )}
        </Box>
      </Box>
      <Box className={classes.box}>
        <Typography className={classes.label}>Current Risks</Typography>
        <Box
          className={clsx(classes.snacks, {
            // [classes.none]: !horse.risks.length
            [classes.none]: true
          })}
        >
          {/*{horse.risks.length ? renderSnacks(horse.risks) : "None"}*/}
          None
        </Box>
      </Box>
      <Box className={classes.grow} />
      <Box className={clsx(classes.box, classes.action)}>
        <Link className={classes.moreInfoLink} onClick={handleMoreInfoClick}>
          <Typography className={classes.moreInfoLinkText}>
            View More Horse Information
          </Typography>
        </Link>
      </Box>
    </Paper>
  );
};

export default withClickBlocker(HorseWorkoutInfo);
